import type { RouteObject } from "react-router"

export const dashboardRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () => import("./dashboard-page").then((m) => ({ Component: m.DashboardPage })),
  },
]
